/**
 * Every cart discount shape we work with - the raw one coming from the cart
 * discount queries and the one nested in an applied `DiscountedLineItemPortion`
 * - exposes the same commercetools fields, so all getters below accept both.
 * They only read fields that mean the same thing for every discount category;
 * anything category specific (how many identical products a volume discount
 * needs, how many different products the distinct products discount needs, ...)
 * belongs to that category's own helper.
 */
export type CartDiscountFieldsSource = {
  cartPredicate?: Maybe<string>;
  value?: Maybe<{ type?: string; permyriad?: Maybe<number> }>;
  custom?: Maybe<{
    customFieldsRaw?: Maybe<{ name: string; value: unknown }[]>;
  }>;
};

export const getDiscountCustomField = (
  discount: Maybe<CartDiscountFieldsSource>,
  fieldName: string,
): unknown => {

  return discount?.custom?.customFieldsRaw?.find(field => field.name === fieldName)?.value;

};

/**
 * Percentage the discount takes off, read from the commercetools relative value
 * (permyriad), so it never has to be hardcoded on our side.
 */
export const getDiscountPercentage = (discount: Maybe<CartDiscountFieldsSource>): number => {

  return (discount?.value?.permyriad || 0) / 100;

};
